import Swiper, { Pagination, Lazy } from 'swiper';
Swiper.use([Pagination, Lazy]);

export default function setIcons() {
  const carousel = document.querySelector('[data-icons] .swiper');
  const pagination = document.querySelector('[data-icons] .swiper-pagination');

  new Swiper(carousel, {
    slidesPerView: 1,
    spaceBetween: 15,
    watchOverflow: true,
    preloadImages: false,
    speed: 1000,
    lazy: {
      checkInView: true,
      loadPrevNext: false,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}
